export class DropdownItem {

    constructor(public key: string, public value: string) {
        this.key = key;
        this.value = value;
    }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/dropdown-item.ts